import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { API } from '@/config/api';

const UserSelectionPage = () => {
    const { impersonateUser } = useAuth();
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axios.get(`${API}/users`);
                setUsers(Array.isArray(response.data) ? response.data : []);
            } catch (error) {
                console.error("Failed to fetch users:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    const handleSelectUser = (user) => {
        impersonateUser(user);
        if (user.role === 'admin') {
            navigate('/admin');
        } else if (user.role === 'manager') {
            navigate('/manager');
        } else {
            navigate('/dashboard');
        }
    };

    return (
        <div className="min-h-screen mafia-gradient flex flex-col items-center justify-center p-4">
            <div className="max-w-4xl w-full space-y-8">
                <div className="text-center">
                    <h1 className="text-5xl font-black text-white mb-2 tracking-tight">
                        🤌 <span className="gold-text">Don Doit</span> 🇫🇷
                    </h1>
                    <p className="text-xl text-zinc-400 font-medium">Select Identity - La Famiglia QuiteBold</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {loading ? (
                        <div className="col-span-full flex justify-center py-12">
                            <Loader2 className="w-12 h-12 text-white animate-spin" />
                        </div>
                    ) : (
                        users.map((user) => (
                            <Card
                                key={user.id}
                                className="cursor-pointer hover:shadow-lg transition-all duration-300 card-mafia text-white min-h-[140px] flex flex-col justify-center"
                                onClick={() => handleSelectUser(user)}
                                role="button"
                                tabIndex={0}
                            >
                                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                    <CardTitle className="text-xl font-bold">{user.name}</CardTitle>
                                    <div className={`px-2 py-1 rounded-full text-xs font-semibold uppercase tracking-wide
                  ${user.role === 'admin' ? 'bg-red-100 text-red-800' :
                                            user.role === 'manager' ? 'bg-blue-100 text-blue-800' :
                                                'bg-green-100 text-green-800'}`}>
                                        {user.role}
                                    </div>
                                </CardHeader>
                                <CardContent>
                                    <div className="text-sm text-zinc-400 mb-4">{user.email}</div>
                                    <div className="text-xs text-zinc-600">ID: {user.id.slice(0, 8)}...</div>
                                </CardContent>
                            </Card>
                        )))}
                </div>
            </div>
        </div>
    );
};

export default UserSelectionPage;
